import { AfterViewInit, Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Course, Learnspace } from '@shared/models';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { environment } from '@env/environment';
import { InternalAnalyticsService } from '@shared/services/internalAnalytics.service';

@Component({
  selector: 'program-index',
  templateUrl: './program-index.component.html',
  styleUrls: ['./program-index.component.scss']
})
export class ProgramIndexComponent implements OnInit, AfterViewInit {
  public course: Course;
  public program: Learnspace;
  public simulationList: Course[];

  @ViewChildren('list') listElement!: QueryList<ElementRef>;

  constructor(
    private _courseService: CoursesAPIService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _internalAnalyticsService: InternalAnalyticsService
  ) {}

  async ngOnInit() {
    if (window.parent) {
      this._internalAnalyticsService.hideChat();
    };

    const courseId = this._route.snapshot.paramMap.get('courseId');
    this.course = await this._courseService.getCourseViewLazy(courseId).toPromise();
    this.program = this.course.learnspace;
    const courses = await this._courseService.getProgramCourseList(this.course.learnspace_id).toPromise();
    this.simulationList = courses.sort((a, b) => a.position - b.position);
  }

  ngAfterViewInit() {
    this.listElement.changes.subscribe(() => {
      const nextSimumation = this.simulationList.find(c => c.position === this.course.position + 1);
      if (nextSimumation) {
        this.scrollTo(nextSimumation.id, 256);
      } else {
        this.scrollTo(this.course.id);
      }
    });
  }

  private scrollTo(elementId: string, delta: number = 0) {
    const el = document.getElementById(elementId);
    if (el) {
      el.parentElement.scrollTop = el.offsetTop - delta;
    }
  }

  openAssessment(courseId: string, sessionId: string) {
    const url = `player-view/courses/${courseId}/sessions/${sessionId}/report`;
    this._router.navigate([url], {
      queryParams: {
        originalCourseId: this.course.id
      }
    });
  }

  openCourse(id: string) {
    this.openURL(`${environment.coursesApiUrl}/api/courses/${id}/room`);
  }
  
  private openURL(url: string) {
    (window.top || window).location.assign(url);
  }
}
